import React, { useEffect } from 'react';
import { FileType, Info } from 'lucide-react';
import './ConverterControls.css';

const ConverterControls = ({ settings, onChange, inputFile }) => {
    const format = settings.format || 'png';
    const quality = settings.quality || 90;

    // 1. Detect Uploaded File Extension
    const inputExt = inputFile?.name ? inputFile.name.split('.').pop().toLowerCase() : '';
    
    // Normalize (e.g., 'jpeg' -> 'jpg')
    const currentFormat = inputExt === 'jpeg' ? 'jpg' : inputExt;

    const update = (key, value) => {
        onChange({ ...settings, [key]: value });
    };

    // 2. Auto-switch if the default format matches the input (e.g. Input PNG -> Auto select JPG)
    useEffect(() => {
        if (currentFormat && format === currentFormat) {
            // Find first format that ISN'T the current one
            const nextFormat = FORMATS.find(f => f.id !== currentFormat);
            if (nextFormat) {
                update('format', nextFormat.id);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentFormat]);

    const FORMATS = [
        { id: 'png', label: 'PNG', desc: 'High Quality' },
        { id: 'jpg', label: 'JPG', desc: 'Compact Size' },
        { id: 'webp', label: 'WEBP', desc: 'Modern Web' },
        { id: 'gif', label: 'GIF', desc: 'Better' },
    ];

    return (
        <div className="converter-controls fade-in">
            
            {/* Format Selection */}
            <div className="control-section">
                <div className="control-header">
                    <label className="section-label">Target Format</label>
                    <FileType size={14} className="icon-subtle" />
                </div>
                
                <div className="format-grid">
                    {FORMATS.map((f) => {
                        // Check if this format matches uploaded file
                        const isDisabled = currentFormat === f.id;

                        return (
                            <button
                                key={f.id}
                                className={`format-card ${format === f.id ? 'active' : ''} ${isDisabled ? 'disabled' : ''}`}
                                onClick={() => !isDisabled && update('format', f.id)}
                                disabled={isDisabled}
                                title={isDisabled ? "Same as original file" : `Convert to ${f.label}`}
                            >
                                <span className="format-title">{f.label}</span>
                                <span className="format-desc">
                                    {isDisabled ? 'Original' : f.desc}
                                </span>
                            </button>
                        );
                    })}
                </div>
            </div>

            {/* Quality Slider */}
            <div className="control-section">
                <div className="control-header">
                    <label className="section-label">Quality</label>
                    <span className="value-badge">{quality}%</span>
                </div>

                <div className="slider-group">
                    <div className="slider-track-bg">
                        <div className="slider-track-fill" style={{ width: `${quality}%` }} />
                    </div>
                    <input 
                        type="range" min="10" max="100" step="5"
                        value={quality}
                        onChange={(e) => update('quality', parseInt(e.target.value))}
                        className="custom-range-slider"
                    />
                </div>
                <div className="slider-labels">
                    <span>Smaller File</span>
                    <span>Best Quality</span>
                </div>
            </div>

            
        </div>
    );
};

export default ConverterControls;